<template>
  <div ref="upload_area">
    <slot name="body">
      <div class="upload_area">
        <div class="plnote" v-if="fileList.length == 0">
          <a-icon type="cloud-upload" />
          <div class="pldesc">{{ $t('publish.addDes') }}</div>
          <span v-if="up_type == 'sourceimg'">{{ $t('publish.addDesL') }}</span>
        </div>
        <div class="pl-show-img">
          <div class="item-box" v-for="(item, index) in fileList" :key="index">
            <div class="item-img" v-html="item.percent" v-bind:style="{ backgroundImage: 'url(' + item.bgImg + ')' }">
            </div>
            <div class="item-info">
              <div class="info-data" v-html="item.name"></div>
              <a href="javascript:void(0);" @click.stop="delFile(index, item.id)">{{ $t('actionTitles.delete') }}</a>
            </div>
          </div>
        </div>
      </div>
    </slot>
    <a-modal :title="$t('upload.cutImage')" :visible="CropModalVisible" @ok="confirmCrop" @cancel="cancelCrop">
      <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType" :info="true"
        :full="option.full" :canMove="option.canMove" :canMoveBox="option.canMoveBox" :fixedBox="option.fixedBox"
        :original="option.original" :autoCrop="option.autoCrop" :autoCropWidth="option.autoCropWidth"
        :autoCropHeight="option.autoCropHeight" :centerBox="option.centerBox" :high="option.high"
        :infoTrue="option.infoTrue" style="width:100%;height:300px;" :enlarge="option.enlarge">
      </vueCropper>
    </a-modal>
  </div>
</template>

<script>
import api from "../api/index";
import request from "@/utils/request";
import { VueCropper } from 'vue-cropper';
import { mapGetters } from "vuex";

export default {
  components: { VueCropper },
  props: {
    'uptype': String, //外部傳入的場景類型
    'callback': Function, //外部傳入的回調方法，如有傳該值，則實例化完成後會在回調方法中返回實例化後的上傳對像uploader
  },
  data() {
    return {
      up_type: null,
      completed: false, //所有文件是否上傳完成，當上傳完成更新為true
      uploader: null,
      fileList: [],
      //定義各條件下的上傳限制條件
      upfilter: {
        //全景圖片
        sourceimg: { filesize: '500mb', filetype: 'jpg,jpeg', filetype2: 'image/jpg,image/jpeg', multi_select: true, autoupload: true, preview: true },
        //素材圖片
        pic: { filesize: '0', filetype: 'jpg,jpeg,gif,png', filetype2: 'image/jpg,image/jpeg,image/gif,image/png', multi_select: true, autoupload: true, preview: true },
        //上傳頭像
        avatar: { filesize: '0', filetype: 'jpg,jpeg,gif,png', filetype2: 'image/jpg,image/jpeg,image/gif,image/png', multi_select: false, autoupload: false, crop: true },
        //上傳平台logo
        logo: { filesize: '0', filetype: 'jpg,png', filetype2: 'image/jpg,image/png', multi_select: false, autoupload: true },
        //視頻（包括全景視頻）
        video: { filesize: '0', filetype: 'mp4,mov', filetype2: 'video/mp4,video/quicktime', multi_select: true, autoupload: true },
        //音頻
        audio: { filesize: '0', filetype: 'mp3', filetype2: 'audio/mp3', multi_select: true, autoupload: true },
        //上傳廣告
        ads: { filesize: '2mb', filetype: 'jpg,jpeg,gif,png', filetype2: 'image/jpg,image/jpeg,image/gif,image/png', multi_select: false, autoupload: true },
        //文章分類封面
        artPoster: { filesize: '5mb', filetype: 'jpg,jpeg,gif,png', filetype2: 'image/jpg,image/jpeg,image/gif,image/png', multi_select: false, autoupload: true, preview: true },
        //圖標
        icon: { filesize: '1mb', filetype: 'jpg,jpeg,gif,png', filetype2: 'image/jpg,image/jpeg,image/gif,image/png', multi_select: false, autoupload: true },
        //apk
        apk: { filesize: '200mb', filetype: 'apk', filetype2: 'application/vnd.android', multi_select: false, autoupload: true },
        //替換全景圖片
        replaceSourceimg: { filesize: '200mb', filetype: 'jpg,jpeg', filetype2: 'image/jpg,image/jpeg', multi_select: false, autoupload: true, preview: true },
        //全景視頻封面
        cover: { filesize: '2mb', filetype: 'jpg,jpeg,png', filetype2: 'image/jpg,image/jpeg,image/png', multi_select: false, autoupload: true },
        //全景視頻
        panoramic: { filesize: '1000mb', filetype: 'mp4,mov', filetype2: 'video/mp4,video/quicktime', multi_select: false, autoupload: true },
        //作品升級
        modelsZip: { filesize: '0', filetype: 'zip', filetype2: 'application/x-zip-compressed', multi_select: false, autoupload: true },
      },
      CropModalVisible: false,
      //裁剪圖片的參數
      option: {
        img: '',
        autoCrop: true,
        autoCropWidth: 200,
        autoCropHeight: 200,
        canMove: true,
        canMoveBox: false,
      },
      //裁剪圖片時選中的圖片
      cropSelectedFile: "",
    };
  },
  computed: {
    ...mapGetters([
      "userInfo"
    ]),
  },
  methods: {
    //刪除上傳框中的文件
    delFile(index, id) {
      //remove上傳實例中的file
      for (var i = 0; i < this.uploader.files.length; i++) {
        if (id == this.uploader.files[i].id) {
          this.uploader.removeFile(this.uploader.files[i]);
        }
      }
      this.fileList.splice(index, 1);
      this.$emit("updateImagefiles", this.fileList);
    },
    returnFileList() {
      this.$emit("updateImagefiles", this.fileList);
    },
    confirmCrop(e) {
      let _this = this;
      this.$refs.cropper.getCropBlob((data) => {
        _this.uploader.addFile(data, _this.cropSelectedFile);
        _this.uploader.start();
      });
      setTimeout(() => {
        _this.CropModalVisible = false;
      }, 500);
    },
    cancelCrop(e) {
      this.CropModalVisible = false;
      this.cropSelectedFile = "";
    },
  },
  mounted() {
    // console.log("_this.upfilter:", this.upfilter);

    let _this = this;
    _this.up_type = this.uptype;
    // console.log("_this.upfilter:", this.uptype);
    request({
      url: api.UploadToken,
      method: "post",
      data: {
        uptype: _this.up_type
      },
    })
      .then((res) => {
        let data = res.data;
        let up_dom = _this.$refs.upload_area;
        let drop_dom = up_dom;
        _this.uploader = uploadPlupload(
          data.up_url,
          data.sign,
          up_dom,
          drop_dom,
          _this.upfilter[_this.up_type].filetype,
          _this.upfilter[_this.up_type].filetype2,
          _this.upfilter[_this.up_type].filesize,
          _this.upfilter[_this.up_type].autoupload,
          data.prefix,
          _this.upfilter[_this.uptype].multi_select,
          data.storage
        );
        //添加了文件
        _this.uploader.bind("FilesAdded", function (up, files) {
          //選擇了文件，則更新完成的狀態
          _this.completed = false;
          _this.$emit("startUploadImage")
          for (let i = 0; i < files.length; i++) {

            let file = files[i];
            let ele_id = file.id;

            //文件名稱，去掉後綴
            var nindex = file.name.lastIndexOf(".");
            var new_name = file.name.substring(0, nindex);
            var suffix = file.name.substring(nindex);
            let row = {
              id: ele_id,
              name: new_name,
              bgImg: "",
              percent: _this.$t('upload.waitUpload'),
              filesize: parseInt(file.size / 1024), //KB
            };

            //多選
            if (_this.upfilter[_this.up_type].multi_select == true) {
              _this.fileList.push(row);
            }
            //單選，銷毀實例中之前選擇的文件
            else {
              for (var i2 = 0; i2 < _this.uploader.files.length - 1; i2++) {
                _this.uploader.removeFile(_this.uploader.files[i2]);
              }
              _this.fileList = [row];
            }

            //如果要裁剪
            if (_this.upfilter[_this.up_type].crop == true) {
              if (_this.cropSelectedFile == "") {
                //利用plupload的預覽方法，取得圖片傳給cropper
                plpreviewImage(file, false, function (imgsrc) {
                  _this.CropModalVisible = true;
                  _this.option.img = imgsrc;
                  _this.$nextTick(() => {
                    _this.cropSelectedFile = file.name;
                    _this.$refs.cropper.startCrop();
                  });
                });
              }
            }

            //生成縮略圖，注意：生成縮略圖是異步的，要注意數據與結果的對應
            if (_this.upfilter[_this.up_type].preview == true) {
              !(function (i) {
                plpreviewImage(file, true, function (imgsrc, ele_id, width, height) {
                  //全景圖上傳，如果寬高比不是2：1，則刪除fileList，並銷毀上傳實例的列表中對應的一行
                  if (_this.up_type == 'sourceimg') {
                    if (parseInt(height * 2) != width) {
                      _this.uploader.removeFile(file);
                      _this.fileList.splice(_this.fileList.length - 1, 1);
                      _this.$message.error(row.name + _this.$t('upload.imageSizeInfo'));
                      return false;
                    }
                  }
                  //返回圖片給fileList
                  for (let i2 = 0; i2 < _this.fileList.length; i2++) {
                    if (_this.fileList[i2].id == ele_id) {
                      if (row.filesize < 60000 && imgsrc.length <= 5000) {
                        _this.fileList[i2].bgImg = imgsrc;
                      }
                      else {
                        _this.fileList[i2].bgImg = '/ssr/static/images/default.png';
                      }
                    }
                  }
                });
              })(i);
            }
          }
        });

        //綁定文件的上傳路徑
        _this.uploader.bind("FileUploaded", function (up, file) {
          for (let i2 = 0; i2 < _this.fileList.length; i2++) {
            if (_this.fileList[i2].id == file.id) {
              _this.fileList[i2].key = data.prefix + file.target_name;
              _this.fileList[i2].url = data.cdn_host + '/' + data.prefix + file.target_name;
            }
          }
        });

        //上傳進度顯示
        _this.uploader.bind("UploadProgress", function (up, file) {
          for (let i2 = 0; i2 < _this.fileList.length; i2++) {
            if (_this.fileList[i2].id == file.id) {
              _this.fileList[i2].percent = file.percent + "%";
              _this.$emit("updateFileProgress", file.percent);
            }
          }
        });

        //上傳結束，更新上傳狀態
        _this.uploader.bind("UploadComplete", function (up, file) {
          _this.completed = true;
          _this.$emit("updateImagefiles", _this.fileList);
          _this.cropSelectedFile = "";
        });

        //捕捉錯誤信息
        _this.uploader.bind("Error", function (up, err) {
          if (err.code == '-600') {
            _this.$message.error(_this.$t('upload.fileSizeLimit') + _this.upfilter[_this.up_type].filesize);
          }
          _this.$emit("uploadFail")
        });

        if (typeof _this.callback == "function") {
          console.log("通過回調返回上傳實例給外部");
          _this.callback(_this.uploader);
        }

      })
      .catch((err) => {
        console.log("plupload err: ", err);
        _this.$emit("uploadFail")
      });
  },
};
</script>

<!--拖拽上傳的樣式-->
<style lang="less" scoped>
.upload_area {
  min-height: 350px;
  padding: 20px;
  padding-left: 30px;
  cursor: pointer;
  color: #2c3e50;
}

.plnote {
  text-align: center;
  padding: 80px 0;
}

.plnote i {
  font-size: 5rem;
}

.pldesc {
  font-size: 32px;
}

.pl-show-img {
  display: flex;
  flex-wrap: wrap;
}

.pl-show-img .item-box {
  width: 23%;
  min-width: 180px;
  background: #f3f3f3;
  margin: 0 2% 10px 0;
  overflow: hidden;
  display: flex;
}

.pl-show-img .item-img {
  width: 80px;
  height: 80px;
  flex-shrink: 0;
  float: left;
  color: #fff;
  text-align: center;
  line-height: 80px;
  background: #333;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: auto 100%;
}

.pl-show-img .item-info {
  padding: 8px 10px 0 10px;
  height: 80px;
  width: 100%;
  overflow: hidden;

  .info-data {
    word-wrap: break-word;
    word-break: break-all;
    height: 45px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .deleteWord {
    color: #7101ad;
  }
}

@media (max-width: 768px) {
  .pldesc {
    font-size: 16px;
  }

  .plnote {
    padding: 40px 0;

    span {
      font-size: 12px;
    }
  }

  .upload_area {
    min-height: 200px;
    padding: 0;
  }

  .pl-show-img .item-box {
    width: 100%;
  }
}
</style>
